import React, { useState, useEffect } from 'react'
import Modal from 'components/modal'
import ICSelect from 'containers/project-creation/create-view/select'
import 'less/scheduler/import-moderator-availability-modal.less'

const ImportModeratorAvailabilityModal = props => {
  const [templateType, setTemplateType] = useState(props.externalCalendar.length >0  ? 0 : -1)
  const [calendarLink, setCalendarLink] = useState(props.externalCalendar)
  const [calendarKey, setCalendarKey] = useState(props.externalCalendarKey)
  const [showError, setShowError] = useState(false)
  const [showKeyError, setShowKeyError] = useState(false)

  useEffect(() => {
    setShowError(false)
    setShowKeyError(false)
    props.setShowUniqueURLError({value: false})
  }, [calendarLink, calendarKey])

  const submit = () => {
    if (!calendarLink.startsWith("https://docs.google.com/spreadsheets/")) {
      setShowError(true)
    } else if(!calendarKey) {
      setShowKeyError(true)
    } 
    else {
      props.onSubmit(calendarLink, calendarKey)    
    }
  }
  const onClick = () => {
   props.unlinkModal()
   props.toggleImportModeratorAvailabilityModal()
  }
  const updateGoogleSheet =(value) =>{
  setTemplateType(value)
  props.updateGoogleSheet()    
  }
  return (
    <Modal
      title={`Import Moderator's Availability`}
      isOpen={props.isOpen}
      className="import-moderator-availability-modal"
      type="modal"
      autoFocusSubmit={false}
      submitBtnText="Confirm"
      onCancel={props.onClose}
      onSubmit={() => submit()}
      isSubmitting={props.isSubmitting}
      enableSubmit={templateType !== -1 && calendarLink && props.importAvStatus !== "In Progress"}
    >
        
      <div>{props.t('import.availability.modal.message')}</div>
      {props.importAvStatus ==="Completed" && <div className="unlink-calendar"><div className='unlink-moderator'><strong>{props.moderatorName.split(' ').slice(0, -1)}'s {props.t('external-availability-link-label')}</strong></div>
      <div className='unlink-content'>
      <div className='unlink-image'>
      
      </div>
      <button className="unlink-button btn-primary" onClick={onClick}>
      <span className='unlink-availability'>
      {props.t('unlink-availability')}
        </span>
      </button>
      
      </div>
      
      </div> }
      {props.importAvStatus ==="Completed" &&  <div className="line" />}
      <div className='moderator-label'><strong>Moderator:</strong>{props.moderatorName}</div>
      <div className='template-container'>
        <ICSelect
          title={props.t('import.availability.modal.template.type')}
          placeholder={"Select Template Type"}
          options={[{value: 0, label: 'Google Doc Template POC'}]}
          value={templateType}
          onChange={({ value }) => updateGoogleSheet(value)}
          name="templateType"
          className="template-type-select"
        />
        {templateType !== -1 && props.downloadGoogleSheetLoading == false && <a  className={`download-template-btn`}
         href='https://docs.google.com/spreadsheets/d/1Fsy6WFHCB4gHRqMSP6WTqzhmgztFDFYGtMi1kmij3-0/export?format=xlsx&gid=0'><i className="im-ss-downloadcloud" /><span> Download Template </span></a> }
      </div>
      <div className='external-availability-link-label'>{props.t('external.availability.link.label')}</div>
      <input className={`external-calendar-link-input${showError ? "-error" : ""}`} type="text" name="calendar-link"
          placeholder="https://docs.google.com/spreadsheets/…"
          onChange={e => setCalendarLink(e.target.value)}
          value={calendarLink}
      />
      {showError ?
        <div className='error-message'> {props.t('import.link.error')} </div> : props.showURLAlreadyUsedError? <div className='error-message' dangerouslySetInnerHTML={{
          __html: props.t('import.link.already.used.error', {
              markup: { tagStart: `${props.otherModeratorName}` }
          })
      }} />
        :
        calendarLink.length > 0 && <a className='view-spreadsheet-btn' href={calendarLink} target="_blank">
          <i className="im-ss-redirect" /><span> View Spreadsheet Link</span></a>
      }
      <div className='external-availability-key-label'>{props.t('external.availability.key.label')}</div>
      <input className={`external-calendar-key-input${showError ? "-error" : ""}`} type="text" name="calendar-key"
          placeholder="AIzaRyDVC-RqySpZQvUo-RASq-DFCzXx8io4rXM"
          onChange={e => setCalendarKey(e.target.value)}
          value={calendarKey}
      />
      {showKeyError && <div className='error-message'> {props.t('import.key.error')} </div>}
    </Modal>
  )
}

export default ImportModeratorAvailabilityModal
